// various types of waters with their respective properties
// - Calcium [mg/L]
// - Magnesium [mg/L]
// Bicarbonates [mg/L]

export class Water {
  name: string;
  calcium: number;
  magnesium: number;
  bicarbonates: number;

  GH: number;
  KH: number;

  constructor({
    name,
    calcium,
    magnesium,
    bicarbonates,
  }: {
    name: string;
    calcium: number;
    magnesium: number;
    bicarbonates: number;
  }) {
    this.name = name;
    this.calcium = calcium;
    this.magnesium = magnesium;
    this.bicarbonates = bicarbonates;

    this.GH = this.generalHardness();
    this.KH = this.alcalinity();
  }

  generalHardness(): number {
    return this.calcium * 2.5 + this.magnesium * 4.1;
  }

  alcalinity(): number {
    return (this.bicarbonates * 50) / 61;
  }
}

export const waters: Water[] = [
  new Water({
    name: "Distilled",
    calcium: 0,
    magnesium: 0,
    bicarbonates: 0,
  }),
  new Water({
    name: "Volvic",
    calcium: 12,
    magnesium: 8,
    bicarbonates: 74,
  }),
  new Water({
    name: "Evian",
    calcium: 78,
    magnesium: 24,
    bicarbonates: 357,
  }),
  new Water({
    name: "Fiji",
    calcium: 18,
    magnesium: 15,
    bicarbonates: 152,
  }),
  new Water({
    name: "Perrier",
    calcium: 147,
    magnesium: 3,
    bicarbonates: 390,
  }),
  new Water({
    name: "San Pellegrino",
    calcium: 179,
    magnesium: 51,
    bicarbonates: 607,
  }),
];
